import HCArticleContent from "../../Shared/Content/content";
import HelpCenterArticleContentHeader from "../../Shared/Header/header";
import classes from "./content.scss";

const HCArticleDesktopContent = ({ title, content, children = null }) => (
  <article className={classes.root}>
    <HelpCenterArticleContentHeader>{title}</HelpCenterArticleContentHeader>
    <HCArticleContent content={content} />
    {children}
  </article>
);

export default HCArticleDesktopContent;
